import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ResetIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "11"}
      height={height || "11"}
      viewBox="0 0 11 11"
    >
      <path
        id="Path_10158"
        data-name="Path 10158"
        d="M-10.26-13.75a5.481,5.481,0,0,0-3.789,1.523l-.792-.792a.532.532,0,0,0-.909.376v2.973a.532.532,0,0,0,.532.532h2.973a.532.532,0,0,0,.376-.909l-.926-.926a3.7,3.7,0,0,1,2.511-1A3.726,3.726,0,0,1-6.524-8.218,3.9,3.9,0,0,1-7.861-5.39a3.5,3.5,0,0,1-2.389.866A3.7,3.7,0,0,1-12.7-5.446a.266.266,0,0,0-.363.012l-.88.88a.267.267,0,0,0,.011.387A5.48,5.48,0,0,0-10.25-2.75a5.5,5.5,0,0,0,5.5-5.5A5.51,5.51,0,0,0-10.26-13.75Z"
        transform="translate(15.75 13.75)"
        fill={color || "#fb972e"}
      />
    </svg>
  );
}
